Object.defineProperty(exports,"__esModule",{value:true});exports.defaultConfig=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.








mergeConfig=mergeConfig;var _deepAssign=require('deep-assign');var _deepAssign2=_interopRequireDefault(_deepAssign);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultConfig=exports.defaultConfig={responseType:'json',headers:{'Content-Type':'application/json'}};function mergeConfig(){
var defaults=_extends({},defaultConfig,{headers:_extends({},defaultConfig.headers)});for(var _len=arguments.length,objects=Array(_len),_key=0;_key<_len;_key++){objects[_key]=arguments[_key];}

return _deepAssign2.default.apply(undefined,[{},defaults].concat(objects));
}